module.exports = __webpack_public_path__ + "img/jspx.20b0dd58.png";